import React from 'react'

const Footer = ({ onOpenModal }) => (
  <footer className="foot">
    <div className="vt-shell">
      <div className="foot__top">
        <div>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 26, color: '#fff', marginBottom: 18 }}>Fetchy</div>
          <p className="foot__about">Outil de prescription nutritionnelle pour carnivores domestiques, conçu pour les vétérinaires. Fondé sur FEDIAF, AAFCO & la littérature scientifique.</p>
        </div>
        <div className="foot__cols">
          <div className="foot__col">
            <h5>Produit</h5>
            <a href="#how-it-works">Comment ça marche</a>
            <a href="#pricing">Tarifs</a>
            <a href="#faq">FAQ</a>
            <a href="https://app.fetchy.vet">Connexion</a>
          </div>
          <div className="foot__col">
            <h5>Communauté</h5>
            <a href="#" onClick={(e) => { e.preventDefault(); onOpenModal && onOpenModal('student'); }}>Accès étudiant gratuit</a>
            <a href="https://arginine-formation.com" target="_blank" rel="noopener noreferrer">Se former avec Arginine</a>
            <a href="#contact">Contact</a>
          </div>
        </div>
      </div>
      <div className="foot__bottom">
        <div className="foot__legalrow">
          <a href="#" onClick={(e) => { e.preventDefault(); onOpenModal && onOpenModal('legal'); }}>Mentions légales</a>
          <a href="#" onClick={(e) => { e.preventDefault(); onOpenModal && onOpenModal('legal'); }}>Confidentialité</a>
          <a href="#" onClick={(e) => { e.preventDefault(); onOpenModal && onOpenModal('legal'); }}>CGU</a>
        </div>
        <div className="foot__lang">
          <span className="foot__lang-badge foot__lang-badge--active">FR</span>
          <span className="foot__lang-badge foot__lang-badge--disabled">EN</span>
        </div>
        <p className="foot__copy">
          La prescription nutritionnelle relève de la médecine vétérinaire. En cas de problème, consultez votre vétérinaire habituel ou le prescripteur.<br />
          &copy; 2026 Fetchy — The Stable Company, 44 Woodland Rise, London N10 3UG.
        </p>
      </div>
    </div>
  </footer>
)

export default Footer
